import React from 'react';

interface VideoPlaceholderProps {
    onPlay?: () => void;
}

const VideoPlaceholder: React.FC<VideoPlaceholderProps> = ({ onPlay }) => {
    return (
        <>
            {/* Overlay for contrast */}
            <div className="relative z-40 h-full w-fit flex-row items-center justify-center md:mt-32 mt-[400px]">
                <div className="text-white text-center">
                    <div onClick={onPlay}
                         className="w-20 h-20 bg-[#494949]/40 rounded-full flex items-center justify-center mx-auto mb-4 cursor-pointer hover:bg-white/30 transition-all play-button">
                        <div
                            className="w-0 h-0 border-l-[24px] border-l-white border-t-[14px] border-t-transparent border-b-[14px] border-b-transparent ml-1"></div>
                    </div>
                </div>
            </div>

            {/* Desktop: Scroll down indicator */}
            <div className="z-40 hidden md:block absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
                    <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
                </div>
            </div>

            {/* Mobile: Hand scroll gesture */}
            <div className="z-40 md:hidden absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <div className="flex flex-col items-center">
                    <svg
                        className="w-8 h-8 text-white animate-pulse"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            d="M18.5 12c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v4c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V8c0-.83-.67-1.5-1.5-1.5S4 7.17 4 8v8.5c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4V12z"/>
                        <path d="M8 6c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1z"/>
                    </svg>
                    <div className="flex flex-col space-y-1 mt-2">
                        <div className="w-0.5 h-2 bg-white rounded-sm animate-pulse opacity-60"></div>
                        <div className="w-0.5 h-1 bg-white rounded-sm animate-pulse opacity-40"></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VideoPlaceholder;